import { inject, Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { Apollo } from 'apollo-angular';
import { map, Observable } from 'rxjs';
import gql from 'graphql-tag';

@Injectable({
  providedIn: 'root',
})
export class MakeoutboundcallService {
  constructor(
    private route: ActivatedRoute,
    private apollo: Apollo,
  ) {}

  searchPhoneCallAgents(): Observable<any> {
    return this.apollo
      .query({
        query: SEARCH_PHONE_CALL_AGENTS,
        variables: {
          criteria: {
            filters: {
              tenantId: this.route.snapshot.queryParams['tenant'],
            },
          },
        },
      })
      .pipe(map((res: any) => res.data.phoneCallAgents));
  }
}

export const SEARCH_PHONE_CALL_AGENTS = gql`
  query ($criteria: SearchPhoneCallAgentsCriteria!) {
    phoneCallAgents(criteria: $criteria) {
      id
      tenantId
      externalId
      name
      provider
      config
      promptUrl
      context
      customFields
      callIntervals {
        start
        finish
      }
      __typename
    }
  }
`;

export const PhoneCallAgentsResolver: ResolveFn<any> = (route: ActivatedRouteSnapshot) => {
  const apollo = inject(Apollo);

  return apollo
    .query({
      query: SEARCH_PHONE_CALL_AGENTS,
      variables: {
        criteria: {
          filters: {
            tenantId: route.queryParams['tenant'],
          },
        },
      },
    })
    .pipe(map((res: any) => res.data.phoneCallAgents));
};
